/**
 * Tonen van de facets.
 */

import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { setQueryValue } from '../reducers';
import setSearchUrl from '../actions/setSearchUrl';
import ActiveFilters from './ActiveFilters';

class Facets extends Component {

	render ( props ) {

		const {
			categories,
			activeCategories,
			tools,
			activeTools,
			queryValue,
		} = this.props.state;

		const handleQueryInput = ( e ) => {
			this.props.dispatch( setQueryValue( e.target.value ) );
		}

		// Trigger om search query te starten na klikken button.
		const handleQueryClick = ( e ) => {
			this.props.dispatch( setQueryValue( queryValue ) );
			this.props.dispatch( setSearchUrl( 'q', queryValue, 'page' ) );
		}

		const handleKeyDownQuery = ( e ) => {
			if ( 13 === e.keyCode ) {
				this.props.dispatch( setQueryValue( e.target.value ) );
				this.props.dispatch( setSearchUrl( 'q', e.target.value, 'page' ) );
			}
		}

		const clearQueryClick = () => {
			this.props.dispatch( setQueryValue( '' ) );
			this.props.dispatch( setSearchUrl( null, null, 'q,page' ) );
			document.querySelector( '.queryValue' ).value = '';
		}

		const handleCategories = ( e ) => {

			e.preventDefault();
			let cat = e.target.value;

			let activeCats = this.props.state.activeCategories.split( ',' );
			let filteredCats = activeCats.filter( c => c );
			let cats = filteredCats.filter( c => c !== cat );

			if ( filteredCats.includes( cat ) ) {
				if ( cats.length > 0 ) {
					this.props.dispatch( setSearchUrl( 'categories', cats.join(), null ) )
				} else {
					this.props.dispatch( setSearchUrl( null, null, 'categories' ) )
				}
			} else {
				cats.push( cat )
				this.props.dispatch( setSearchUrl( 'categories', cats.join(), null ) )
			}
		}

		const handleTools = ( e ) => {

			e.preventDefault();

			let tool = e.target.value;

			let activeTools = this.props.state.activeTools.split( ',' );
			let filteredTools = activeTools.filter( c => c );
			let tools = filteredTools.filter( c => c !== tool );

			if ( filteredTools.includes( tool ) ) {
				if ( tools.length > 0 ) {
					this.props.dispatch( setSearchUrl( 'tech', tools.join(), null ) )
				} else {
					this.props.dispatch( setSearchUrl( null, null, 'tech' ) )
				}
			} else {
				tools.push( tool )
				this.props.dispatch( setSearchUrl( 'tech', tools.join(), null ) )
			}
		}

		return (
			<div className="c-facets u-padding-lg">
				<ActiveFilters />
				<div className="c-form-group">
					<h2 className="c-facets__title">
						Geef je zoekterm in
					</h2>
					<div className="c-facets__input">
						{
							'' !== queryValue ?
								<input onChange={ e => { handleQueryInput( e ); } } onKeyDown={ handleKeyDownQuery } className="c-form c-form-input c-form-input-text queryValue" type="text" placeholder="Zoek artikel" value={ queryValue } />
								:
								<input onChange={ e => { handleQueryInput( e ); } } onKeyDown={ handleKeyDownQuery } className="c-form c-form-input c-form-input-text queryValue" type="text" placeholder="Zoek artikel" />
						}
						{ '' !== queryValue &&
							<button className="c-facets__clear" onClick={ clearQueryClick }><span>Zoekveld leegmaken</span></button>
						} 
					</div>
					<button className="c-button c-button-primary u-margin-top-sm" onClick={ handleQueryClick }>Zoeken</button>

				</div>
				{ categories && categories.length > 0 &&
					<div className="c-form-group">
						<h2 className="c-facets__title">
							Choose categories
						</h2>
						<div>
							{
								categories.map( ( category ) =>
									<div className="c-facets__checkbox">
										<input
											id={ 'cat-' + category.id }
											type="checkbox" value={ category.id }
											onChange={ e => { handleCategories( e ); } }
											checked={ activeCategories && activeCategories.split( ',' ).includes( JSON.stringify( category.id ) ) ? true : false } />
										<label for={ 'cat-' + category.id } >
											<span>
												{ category.label }
											</span>
										</label>
									</div>
								)
							}
						</div>
					</div>
				}

				{ tools && tools.length > 0 &&
					<div className="c-form-group">
						<h2 className="c-facets__title">
							Choose technology
						</h2>
						<div>
							{
								tools.map( ( tool ) =>
									<div className="c-facets__checkbox">
										<input
											id={ 'cat-' + tool.id }
											type="checkbox" value={ tool.id }
											onChange={ e => { handleTools( e ); } }
											checked={ activeTools && activeTools.split( ',' ).includes( JSON.stringify( tool.id ) ) ? true : false } />
										<label for={ 'cat-' + tool.id } >
											<span>
												{ tool.label }
											</span>
										</label>
									</div>
								)
							}
						</div>
					</div>
				}
			</div>
		)
	}
}

function mapStateToProps ( state ) {
	return { state };
}

export default connect( mapStateToProps )( Facets );
